import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import { store, persistor } from '../src/apiServices/store'
import { PersistGate } from 'redux-persist/integration/react';
import './i18n';
import './styles/theme.css';
import './index.css';
import './utils/resizeObserverFix';

const hasPersistedLogin = () => {
  try {
    const raw = localStorage.getItem('persist:root');
    if (!raw) return false;
    const root = JSON.parse(raw);
    const api = typeof root.apiService === 'string' ? JSON.parse(root.apiService) : root.apiService;
    if (!api) return false;
    if (typeof api.token === 'string' && api.token.trim() && api.token !== '[]') return true;
    const login = typeof api.login === 'string' ? JSON.parse(api.login) : api.login;
    const loginToken = login && (login.Token || login.token);
    return loginToken != null && String(loginToken).trim() !== '';
  } catch (e) {
    return false;
  }
};

// Register before React Router so Back cannot open "/" and remount the dashboard.
window.addEventListener('popstate', (event) => {
  const path = window.location.pathname || '/';
  if (path !== '/' && path !== '') return;
  if (!hasPersistedLogin()) return;
  let next = '/landing-page';
  try {
    const last = sessionStorage.getItem('pmr_last_app_path') || '';
    if (last && last !== '/' && !last.startsWith('/?')) next = last;
  } catch (e) {
    // ignore
  }
  event.stopImmediatePropagation();
  window.history.pushState(window.history.state, '', next);
}, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function 
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
